/**
 * 将时间戳（或其他时间值）按照指定格式进行格式化
 * @param {number|string|Date|null|undefined} value - 待转换的值（支持时间戳、Date对象、时间字符串）
 * @param {string} format - 目标格式（支持的占位符：yyyy-MM-dd HH:mm:ss）
 *                          yyyy: 四位年份，MM: 两位月份，dd: 两位日期
 *                          HH: 24小时制两位小时，mm: 两位分钟，ss: 两位秒数
 * @returns {string} 格式化后的时间字符串，若转换失败则返回空字符串
 */
export function formatTime(value, format = "yyyy-MM-dd HH:mm:ss") {
  // 1. 处理空值或无效值
  if (value === null || value === undefined || value === "") {
    return "";
  }

  // 2. 统一转换为Date对象

  let date;
  if (value instanceof Date) {
    // 如果已经是Date对象，直接使用
    date = value;
  } else if (typeof value === "number" || /^\d+$/.test(value)) {
    // 处理数字或数字字符串形式的时间戳
    let timestamp = Number(value);
    // 区分秒级（10位）和毫秒级（13位）时间戳
    if (timestamp.toString().length === 10) {
      timestamp *= 1000;
    }
    date = new Date(timestamp);
  } else if (typeof value === "string") {
    // 处理时间字符串
    // 兼容性处理：在某些浏览器中，new Date("YYYY-MM-DD") 会被解析为 UTC 时间（导致本地时间多出8小时）
    // 而 new Date("YYYY/MM/DD") 会统一解析为本地时间
    let dateString = value;
    if (value.includes("-") && !value.includes("T")) {
      dateString = value.replace(/-/g, "/");
    }
    date = new Date(dateString);
  } else {
    // 无法识别的类型
    return "";
  }

  // 3. 验证Date对象是否有效
  if (isNaN(date.getTime())) {
    return "";
  }

  // 4. 提取时间各部分
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 月份从0开始，需+1
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  // 5. 补零工具函数
  const padZero = (num) => num.toString().padStart(2, "0");

  // 6. 根据格式字符串替换占位符
  return format
    .replace("yyyy", year)
    .replace("MM", padZero(month))
    .replace("dd", padZero(day))
    .replace("HH", padZero(hours))
    .replace("mm", padZero(minutes))
    .replace("ss", padZero(seconds));
}

// // 测试示例
// console.log(formatTime(1748685787, "yyyy-MM-dd HH:mm:ss"));
// // 输出：2025-05-30 15:23:07（秒级时间戳）

// console.log(formatTime(1755246074000, "yyyy年MM月dd日 HH:mm"));
// // 输出：2025年06月15日 11:41（毫秒级时间戳）

// console.log(formatTime(new Date(1672502400000), "yyyy/MM/dd"));
// // 输出：2023/01/01（Date对象）

// console.log(formatTime("2025-05-30T07:23:07Z", "HH:mm:ss"));
// // 输出：15:23:07（ISO时间字符串，自动转换为本地时区）

// console.log(formatTime(null, "yyyy-MM-dd"));
// // 输出：''（空值处理）
